import { createActions } from '../../../context';
import * as actions from './course-list.actions';

export const courseList = store => ({
    pagination: {
        currentPage: 1,
        pageSize: 20,
        pagesCount: 1,
        itemsCount: 0
    },
    filters: {
        clubName: '',
        courseId: '',
        name: '',
        provider: '',
        status: ''
    },
    providers: [],
    items: [],
    selectedCourses: [],
    allSelected: false,
    actions: createActions(actions)(store)
});